import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const loadBaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');
const loadBaseMobileBeta = () => import('@/views/dashboard/mobileBeta/BaseMobileBeta.vue');

const mobileBetaRoutes: RouteRecordRaw[] = [
  {
    path: '/mobile-beta',
    component: loadBaseDashboard,
    meta: {
      title: 'Mobile Beta',
      icon: 'mdi-cellphone',
      noCache: false,
      isBase: true,
      middleware: ['auth'],
      layout: 'Dashboard',
      hidden: true,
      showInMenu: false,
    } as CommonRouteMeta,
    children: [
      {
        path: '',
        component: loadBaseMobileBeta,
        name: 'mobile-beta.index',
        meta: {
          title: 'Mobile Beta',
          icon: 'mdi-cellphone',
          noCache: false,
          isBase: true,
          hidden: true,
          showInMenu: false,
        } as CommonRouteMeta,
      },
    ],
  },
];

export default mobileBetaRoutes;
